import '../../assets/css/archive.css';
import React from 'react';
import {Link, useNavigate} from 'react-router-dom';

// 아카이브 항목 데이터
const archiveItems = [
    { id: 1, text: "조선제학교일람", url: "/archive/colonial_school" },
    { id: 2, text: "조선총독부 직원록 중 학교 및 교원 정보", url: "/archive/redbook" },
    { id: 3, text: "조선총독부관보 서임급사령 중 교원 부분", url: "/archive/gwanbo_personnel" },
    { id: 4, text: "경기도보 서임급사령 중 교원 부분", url: "/archive/dobo_personnel" },
    { id: 5, text: "동경교과서협회 중등학교 직원록 중 조선 내 학교", url: "/archive/middle_school" },
    { id: 6, text: "교우회지 중 학생 및 교원 정보", url: "/archive/alumni" },
    { id: 7, text: "졸업앨범 내 조선인 졸업자 명단", url: "/archive/album" },
    { id: 8, text: "기타 학교자료", url: "/archive/school_catalogue" },
    { id: 9, text: "회고록 목록", url: "/archive/biography" }
];

/**
 * 메인 > 아카이브 > 전체 아카이브 목록
 *
 */
const Archive = () => {
    const navigate = useNavigate(); // 네비게이션

    // 아카이브 항목 클릭 시 이동
    const handleClick = (e, url) => {
        e.preventDefault();
        navigate(url);
    };

    // 아카이브 항목 렌더링
    const renderListItem = (item, index) => {
        const count = index + 1;

        return (
            <li
                key={item.id}
                data-count={count}
            >
                <Link to={item.url} onClick={(e) => handleClick(e, item.url)}>
                    {item.text}
                </Link>
            </li>
        );
    };

    return (
        <main id="contents">
            <div className="sub-content">
                <div className="archive-wrap">
                    <div className="cont-btm type-full">
                        <div className="w-set">
                            <h2 className="archive-tit">
                                한국 근현대 교육사 자료 <span>아카이브</span>
                            </h2>
                            <div className="archive-layout">
                                <div className="list-wrap">
                                    <div className="archive-list">
                                        <div className="list-slides">
                                            <ul className="slides-wrapper">
                                                {archiveItems.map(renderListItem)} {/* 아카이브 항목 렌더링 */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="archive-img"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Archive;
